/**
 * @generated SignedSource<<af21bd61a091526ff0559b7d0adc4de0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConfigureDrop_metadata$data = {
  readonly collections: ReadonlyArray<{
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"CollectionMedia_collection">;
  }>;
  readonly " $fragmentType": "ConfigureDrop_metadata";
};
export type ConfigureDrop_metadata$key = {
  readonly " $data"?: ConfigureDrop_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigureDrop_metadata">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConfigureDrop_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CollectionType",
      "kind": "LinkedField",
      "name": "collections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CollectionMedia_collection"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};

(node as any).hash = "e03c5da4e9e3920f314a7bcb1914fdbd";

export default node;
